
import { ResultData } from "@nt-portal/common-sdk";

import { TCMMasterGroupItem, TCMMasterGroupItemService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { createTCMMasterGroupItem } from "./master-group-items.service";

export interface TCMMasterGroupAvailableItemOptions extends ControllerOptions<TCMMasterGroupItem> {
    importMode?: string;
    groupId?: string;
    scheduleId?: string;
    sheetId?: string
}




export class ClientTCMMasterGroupAvailableItemService extends BaseClientService implements DataController<TCMMasterGroupItem> {

    private _service: TCMMasterGroupItemService;


    constructor() {
        super();
        this._service = new TCMMasterGroupItemService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }


    public init(inObj: Partial<TCMMasterGroupItem>): TCMMasterGroupItem {
        return createTCMMasterGroupItem(inObj);
    }

    public async get(options: TCMMasterGroupAvailableItemOptions): Promise<ResultData<TCMMasterGroupItem>> {

        if (this.params.groupId && options.scheduleId )
            return await this._service.available(this.buildFetchParams(options), this.token, options.scheduleId, options.sheetId, options.filter);
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }

    }



}